var iziworkRule = {
    numbers: [0, 1, 2],
    plurals: function (n) {
        if (n === 0) {
            return 0;
        }
        if (n === 1) {
            return 1;
        }
        return 2;
    },
};
var PluralRules = /** @class */ (function () {
    function PluralRules() {
        this.type = '3rdParty';
        return;
    }
    PluralRules.prototype.init = function (instance) {
        instance.services.pluralResolver.addRule('en', iziworkRule);
        instance.services.pluralResolver.addRule('fr', iziworkRule);
        instance.services.pluralResolver.addRule('it', iziworkRule);
    };
    return PluralRules;
}());
export { PluralRules };
